import type { EventType, TsCodeType, TsTypeType } from '../../types.js'
import {
	jsonClass,
	jsonProperty,
	jsonArrayProperty,
} from '@sumbricht/json-class-serializer'
import { ScreenEditorInput } from '../decorators/screen-editor-input.js'
import { LeafBlock } from '../leaf-block.js'
import { Parameter } from '../../script/parameter.js'

@jsonClass('ChartBlock')
export class ChartBlock extends LeafBlock {
	@jsonProperty(String)
	@ScreenEditorInput({
		inputType: 'code',
		order: 1,
		label: 'Chart configuration (variable)',
		tooltip: () => ({
			text: `Store chart configuration in variable for performance reasons`,
		}),
		codeLanguage: 'ts',
		tsReturnType: () => 'Sys.Types.ChartConfiguration',
		editorSize: 'singleline',
		isBinding: false,
		isMandatory: () => true,
	})
	chartConfigCode?: TsCodeType

	constructor(init: Partial<ChartBlock> = {}) {
		super()
		this.init(init)
	}

	getEditorCategory(): string {
		return 'Chart'
	}

	get allowedEventTypes(): EventType[] {
		return [
			{
				name: 'chartClick',
				parameters: [
					new Parameter({
						name: 'event',
						type: 'any',
						defaultExpression: '$event',
					}),
				],
			},
		]
	}
}
